import HttpClient from "./HttpClient";

export const MintgramURL = new HttpClient(process.env.REACT_APP_API_URL as string);
export const MVPrefabricURL = new HttpClient("https://mvp-api.refabric.com/");

export const RefabricProURL = new HttpClient((process.env.REACT_APP_PRO_API_URL as string) + "/" + (process.env.REACT_APP_PRO_API_VERSION as string));

// Public, unauthenticated blog CMS API (ref-api). Base: {REACT_APP_API_URL}/v1/blog
export const RefabricBlogURL = new HttpClient((process.env.REACT_APP_API_URL as string) + "/v1/blog");
